//src/Components/EmojiPicker/EmojiPreview.tsx
import {
  forwardRef,
  Ref,
  useContext,
  useImperativeHandle,
  useState,
} from 'react';
import { EmojiData, IEmojiPreviewRef } from '.';
import { PreviewEmojiContext } from './contexts';

const EmojiPreview = forwardRef(({}, ref?: Ref<IEmojiPreviewRef>) => {
  const [preview, setPreview] = useState<EmojiData>();
  const { emojiPreviewRef } = useContext(PreviewEmojiContext);
  useImperativeHandle(emojiPreviewRef, () => ({
    setPreview,
  }));

  return (
    <div className="mt-2 w-full h-16  bg-gray-light-10 flex gap-3 px-2 border-t items-center">
      {preview && (
        <>
          <div className="text-xl">{preview?.skins[0].native}</div>
          <div className="text-sm line-clamp-1 text-ellipsis  ">
            <div className="font-bold text-gray-dark line-clamp-1">
              {preview?.id}
            </div>
            <div className="text-gray-light line-clamp-1">:{preview?.id}:</div>
          </div>
        </>
      )}
    </div>
  );
});

export default EmojiPreview;
